import { AbstractCommand } from 'src/models/command';

class SwitchUserStateCommand extends AbstractCommand {
	readonly name = 'IFS_UserState_Command_Commands_SwitchUserstate';

	public constructor(userStateId: number) {
		super();
		this.parameters = {
			userstateId: userStateId,
		};
	}
}

class SetPersonalUserStateCommand extends AbstractCommand {
	readonly name = 'IFS_UserState_Command_Commands_SetPersonalUserstate';

	public constructor(text: string) {
		super();
		this.parameters = {
			text: text,
		};
	}
}

export { SetPersonalUserStateCommand, SwitchUserStateCommand };
